import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const HorsePower: ConvertableUnit = {
  label: "hp",
  toStandardUnit: hp => hp,
  toThisUnit: hp => hp
};

export const Watts: ConvertableUnit = {
  label: "W",
  toStandardUnit: watts => watts / 745.69987,
  toThisUnit: hp => hp * 745.69987
};

export const KiloWatts: ConvertableUnit = {
  label: "kW",
  toStandardUnit: kw => kw / 0.74569987,
  toThisUnit: hp => hp * 0.74569987
};

const unitList = [HorsePower, Watts, KiloWatts];
export const PowerUnits = {
  HorsePower,
  Watts,
  KiloWatts,
  options: buildOptions(unitList)
};
